import getLocal from '@/app/utils/getLocal';
import { NoneShowPathnameArray } from '@/appComps/NoneShowPathnameArray';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import CompA from './CompA';
const NEXT_PUBLIC_MODY = process.env.NEXT_PUBLIC_MODY;
// import getDefaultHeader from 'lowcode/utils/service/getDefaultHeader';

const localSiteMap: Record<string, number> = {
    us: 1,
    ca: 2,
    au: 3,
    za: 4,
    uk: 5,
    eu: 6,
    de: 7,
    fr: 12,
    cn: 13,
    jp: 14,
};

export default function MicrosoftChat() {
    const { pathname = '' } = useRouter();
    const [loadChat, setLoadChat] = useState(false);
    const [payloadData, setPayloadData] = useState<any>({});
    const { locale } = getLocal();

    const originPlayload = {
        $schema: 'http://adaptivecards.io/schemas/adaptive-card.json',
        type: 'AdaptiveCard',
        version: '1.3',
        body: [
            {
                type: 'TextBlock',
                text: 'Ready to try the ECOFLOW AI Assistant?',
                weight: 'bolder',
                style: 'heading',
            },
            {
                type: 'TextBlock',
                size: 'Medium',
                text: 'This assistant is designed solely to support your interactions with ECOFLOW products.',
            },
            {
                type: 'TextBlock',
                size: 'Medium',
                text: '⚠️Please note:',
                weight: 'bolder',
            },
            {
                type: 'TextBlock',
                wrap: true,
                text: '🔹 AI-generated responses are for reference only and do not constitute professional advice or official commitments.\n\n🔹 For important decisions or safety-related issues, please consult human support or official documentation.\n\n🔹 Do not enter any personal or sensitive information, such as ID numbers, bank details, or content related to politics or religion.\n\n🔹 The information you enter during interaction may be used for AI model optimization and service improvement, in full compliance with applicable privacy regulations.',
                spacing: 'medium',
            },
            {
                type: 'TextBlock',
                text: '🔹 For more details, see [Privacy Policy](https://account.ecoflow.com/agreement/en-us/PrivacyPolicy.html) and [AI Assistant Service Disclaimer](https://account.ecoflow.com/agreement/en-us/ECOFLOW-AI-Assistant-Service-Disclaimer.html)',
            },
            {
                type: 'Input.Toggle',
                size: 'small',
                id: '{"Id":"e4bdf7cb-995e-ec11-8f8f-000d3a31376e","Name":"Consent","IsOption":false,"Order":3,"IsRequired":true,"QuestionText":"I have read and agree to the terms above."}',
                title: '***I have read and agree to the terms above**',
                valueOn: 'True',
                valueOff: 'False',
                value: 'false',
                isRequired: true,
                errorMessage: 'You must agree  before continuing.',
            },
            {
                type: 'TextBlock',
                isSubtle: true,
                text: 'Fields marked with * are mandatory.',
                wrap: true,
            },
        ],
        actions: [
            {
                type: 'Action.Submit',
                title: 'Start Chatting',
                data: {
                    Type: 'InputSubmit',
                },
            },
        ],
    };

    const getReturnProps = (payload: any) => {
        return {
            //注入payload
            preChatSurveyPaneProps: {
                controlProps: {
                    payload: JSON.stringify(payload),
                },
            },
            webChatContainerProps: {
                renderingMiddlewareProps: {
                    systemMessageBoxStyles: {
                        maxWidth: '510px', //系统文本宽度（默认的padding 10px）
                    },
                    receivedMessageAnchorStyles: {
                        color: 'blue', //链接颜色
                    },
                },
                adaptiveCardStyles: {
                    background: 'white', //自适应卡片背景颜色
                    color: 'black', //自适应卡片字体颜色
                },
                webChatStyles: {
                    bubbleBackground: 'white', //系统背景颜色
                    bubbleTextColor: 'black', //系统字体颜色
                    bubbleFromUserBackground: '#94ed69', //用户输入文本背景颜色
                    bubbleFromUserTextColor: 'black', //用户输入字体颜色
                    bubbleMaxWidth: 500, //系统聊天文本最大宽度（默认250）
                },
            },
        };
    };

    const getAllLcwForLocale = async () => {
        // const urlStr = encodeURIComponent('origin=Official website&sitename=12');
        // console.log(`https://efcrm.ecoflow.com/api/LiveChat/GetAdaptive?${urlStr}`);
        try {
            const originParams = encodeURIComponent('Official website');
            const res = await fetch(
                `https://efcrm.ecoflow.com/api/LiveChat/GetAdaptive?origin=${originParams}&sitename=${localSiteMap[locale] || localSiteMap['us']}`,
            );
            const result = await res.json();
            if (result && Object.keys(result)?.length > 0) {
                setPayloadData(result);
                return;
            }
            setPayloadData(originPlayload);
        } catch (error) {
            console.log('GetAdaptive error--->>>', error);
            setPayloadData(originPlayload);
        }
    };
    useEffect(() => {
        if (NEXT_PUBLIC_MODY === 'prd' && !NoneShowPathnameArray.includes(pathname)) {
            const openHandleA = () => {
                const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
                if (scrollTop > 300) {
                    getAllLcwForLocale();
                    window.removeEventListener('scroll', openHandleA);
                    setTimeout(() => {
                        setLoadChat(true);
                    }, 2 * 1000);
                }
            };
            window.addEventListener('scroll', openHandleA);
        }
    }, []);
    return <>{loadChat && <CompA payloadData={payloadData} />}</>;
}
